module.exports = __webpack_public_path__ + "img/score.1ae86a0a.png";